import * as actionTypes from "../../Actions";

const initialState = {
    bonuses: [],
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_BONUSES:
            return {
                ...state,
                bonuses: action.payload
            }
        default:
            return state;
    }
}

export default reducer;
